import type { FunctionComponent } from 'react'
import { useTrackEventEffects } from './useTrackEventEffects'
import { useTrackIdentityEffect } from './useTrackIdentityEffect'

export const TrackingSideEffects: FunctionComponent<React.PropsWithChildren<{}>> = ({}) => {
  useTrackEventEffects()
  useTrackIdentityEffect()
  return <></>
}
